export default "__VITE_ASSET__BcQitULl__"